/**
 * FORM_MSG — the ONE source for the standard user-facing strings every form
 * shares (BO UI Standard §7 / §11 / §13).  The shared flows (useSaveFlow,
 * useDeleteFlow) default to these; a new form should reuse them rather than
 * re-typing the wording, so "Saved successfully." etc. can never drift.
 *
 *   import { FORM_MSG } from '../../formKit';
 *   notify.warning(FORM_MSG.NO_SELECTION);
 */
export const FORM_MSG = {
  // ── Save (useSaveFlow) ──────────────────────────────────────────────────
  SAVE_CONFIRM: 'Do you want to Save?',
  SAVED: 'Saved successfully.',
  SAVE_FAILED: 'Save failed. Please try again.',

  // ── Delete (useDeleteFlow) ──────────────────────────────────────────────
  DELETE_TITLE: 'Delete',
  DELETED: 'Deleted.',
  DELETE_FAILED: 'Delete failed. Please try again.',

  // ── Common guards (warnings, not errors — §13) ──────────────────────────
  NO_SELECTION: 'Select at least one row first.',
  SELECT_ONE: 'Select exactly one row.',
  REASON_REQUIRED: 'A reason is required.',

  // ── Author-only note guard (§14a Rule C — the ONE canonical message) ────
  NOTE_NOT_AUTHOR: 'You are not authorized to modify a note created by another author.',
} as const;

export type FormMessageKey = keyof typeof FORM_MSG;
